const reportDeposit = [
	{ text: 'date_time', value: 'date' ,sortable: false, align: 'center'},
	{ text: 'amount', value: 'amount' ,sortable: false, align: 'center'},
	{ text: 'old_balance', value: 'old_balance' ,sortable: false, align: 'center'},
	{ text: 'new_balance', value: 'new_balance' ,sortable: false, align: 'center'},
];

export default reportDeposit;